module.exports = __webpack_public_path__ + "static/space.61b8cb63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/space.jpg
// module id = 1097
// module chunks = 114276838955818